"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SelectInput = function SelectInput(props) {
  var fieldName = props.fieldName,
      id = props.id,
      validation = props.validation,
      value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange,
      options = props.options,
      placeholder = props.placeholder,
      disabled = props.disabled,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$isClearable = props.isClearable,
      isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
      _props$isSearchable = props.isSearchable,
      isSearchable = _props$isSearchable === void 0 ? true : _props$isSearchable,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      size = props.size;
  var selectedOption = props.selectedOption; // Check if options is [{value, label}] or {value: label}.

  var optionsTransformed = options;

  if (!Array.isArray(options)) {
    optionsTransformed = Object.keys(options).map(function (value) {
      var label = options[value];
      return {
        value: value,
        label: label
      };
    });
  } // If the selected option is not set, find the currently selected option by value.


  if (!selectedOption) {
    if (multiple) {
      var _value = value !== undefined ? value : defaultValue || [];

      selectedOption = optionsTransformed.filter(function (option) {
        return _value.includes(option.value);
      });
    } else {
      var _value2 = value !== undefined ? value : defaultValue || '';

      selectedOption = optionsTransformed.find(function (option) {
        return option.value === _value2;
      });
    }
  }

  return /*#__PURE__*/_react.default.createElement(_formik.Field, {
    required: true,
    name: fieldName,
    value: value,
    validate: validation
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    return /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      id: id,
      inputId: fieldName,
      className: (0, _classnames.default)('Select__select', className),
      classNamePrefix: (0, _classnames.default)('Select__inner', wrapperClassName),
      value: selectedOption,
      defaultValue: defaultValue,
      disabled: disabled,
      onChange: function onChange(e) {
        var value = '';

        if (e) {
          if (multiple) {
            value = e.map(function (item) {
              return item.value;
            });
          } else {
            value = e.value;
          }
        } else if (multiple) {
          value = [];
        }

        if (_onChange) {
          _onChange(value);
        }

        form.setFieldValue(fieldName, value);
      },
      options: optionsTransformed,
      isMulti: multiple,
      isOptionDisabled: function isOptionDisabled(option) {
        if (option.disabled) {
          return true;
        }

        if (size && selectedOption.length >= size) {
          return true;
        }

        return false;
      },
      placeholder: placeholder,
      isClearable: isClearable,
      isSearchable: isSearchable,
      theme: {
        borderRadius: 0,
        colors: {
          danger: '#DE350B',
          dangerLight: '#FFBDAD',
          neutral0: 'hsl(0, 0%, 100%)',
          neutral10: 'hsl(0, 0%, 90%)',
          neutral20: 'hsl(0, 0%, 80%)',
          neutral30: 'hsl(0, 0%, 70%)',
          neutral40: 'hsl(0, 0%, 60%)',
          neutral5: 'hsl(0, 0%, 95%)',
          neutral50: 'hsl(0, 0%, 50%)',
          neutral60: 'hsl(0, 0%, 40%)',
          neutral70: 'hsl(0, 0%, 30%)',
          neutral80: 'hsl(0, 0%, 20%)',
          neutral90: 'hsl(0, 0%, 10%)',
          primary: '#f0694b',
          primary25: 'hsla(0,0%,0%, 0)',
          primary50: 'hsla(0,0%,0%, 0)',
          primary75: 'hsla(0,0%,0%, 0)'
        }
      }
    });
  });
};

var _default = SelectInput;
exports.default = _default;